module.exports = __webpack_public_path__ + "img/20191119163121273.ba913b94.jpg";